var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#Messenger_svg__paint0_linear_916_1024)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.84 65v-8.549C19.445 52.377 16 46.171 16 39.222 16 26.95 26.745 17 40 17c13.256 0 24 9.95 24 22.222 0 12.272-10.744 22.222-24 22.222-2.473 0-4.86-.346-7.105-.988L24.84 65zm-.346-18.265l12.943-13.6 6.212 6.302 11.649-6.301-12.87 13.6-6.155-6.414-11.779 6.413z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Messenger_svg__paint0_linear_916_1024",
    x1: 40,
    y1: 5.408,
    x2: 40,
    y2: 76.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })))));
}
export default SvgMessenger;